const API_CONFIG = {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    https: {
        checkServerIdentity: (host, cert) => {
          // Customize certificate verification here, returning an error if the
          // certificate is invalid or should not be trusted.
        }
    },
};

export default API_CONFIG; 